exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody {\n    padding-top: 15px;\n    font-size: 12px;\n}\n.main {\n    max-width: 320px;\n    margin: 0 auto;\n}\nh3 {\n    text-align: center;\n    line-height: 300%;\n}\n", ""]);

// exports
